'use client'

import { useElementVisible } from '@hooks/useElementVisible'
import { InvestorsMock } from '@components/AboutUs/AboutUsMock'
import styles from './InvestorSection.module.scss'
import { InvestorBigCard, InvestorCard } from './InvestorCards'

const InvestorSection = () => {
  const headerSection = useElementVisible({ threshold: 1 })
  return (
    <div className={styles.investorContainer}>
      <div
        ref={headerSection.ref}
        className={`${styles.investorHeaderContainer} ${headerSection.isVisible ? styles.visible : ''}`}>
        <p className={styles.investorHeader1}>{InvestorsMock?.title}</p>
        <p className={styles.investorHeader2}>{InvestorsMock?.description}</p>
      </div>
      <div className={styles.investorAllCardContainer}>
        <div className={styles.investorBigCardsContainer}>
          {InvestorsMock?.bigCards?.map((data, i) => <InvestorBigCard data={data} key={i} />)}
        </div>
        <div className={styles.investorCardsContainer}>
          {InvestorsMock?.cards?.map((data, i) => <InvestorCard data={data} key={i} />)}
        </div>
      </div>
    </div>
  )
}

export default InvestorSection
